import { useState } from "react";
import { useContextComissoes } from "src/Contexts/comissoes/ComissoesContext";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useResetInputs } from "src/Contexts/hooks/useResetInputs";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { ModalDeleteCore } from "src/Pages/components";
import { api } from "src/shared/setup/API/api";

interface IModalChangeIsActiveModalidade {
  modalIsActiveModalidade: boolean;
  setModalIsActiveModalidade: React.Dispatch<React.SetStateAction<boolean>>;
  isActiveModalidade: boolean;
}

export const ModalChangeIsActiveModalidade = ({
  setModalIsActiveModalidade,
  modalIsActiveModalidade,
  isActiveModalidade,
}: IModalChangeIsActiveModalidade) => {
  const { setAttTable } = useConfigPageContext();
  const { valuesInputsModalidade } = useContextComissoes();
  const { handleGetAlert } = useLayoutMainContext();
  const { resetInputs } = useResetInputs();

  const [loading, setLoading] = useState(false);

  const handleIsActiveModalidade = async () => {
    setLoading(true);

    if (!valuesInputsModalidade.name)
      return handleGetAlert({ message: "Nome da modalidade nao encontrado." });

    return api
      .put(`/comissoes/modalidade/status/${valuesInputsModalidade.name}`, {
        name: valuesInputsModalidade.name,
        is_active: isActiveModalidade,
      })
      .then((res) => {
        handleGetAlert({
          message:
            res.data?.message ?? "Status da modalidade atualizado com sucesso.",
        });
        setAttTable((item) => !item);
        resetInputs();
      })
      .catch((error) =>
        handleGetAlert({
          message:
            error.response?.data?.message ??
            "Erro ao atualizar status da modalidade.",
        })
      )
      .finally(() => {
        setModalIsActiveModalidade(false);
        setLoading(false);
      });
  };

  return (
    <ModalDeleteCore
      loading={loading}
      modalOpen={modalIsActiveModalidade}
      no="Não, Cancelar"
      titlePrimary={`Você deseja ${
        !isActiveModalidade ? "DESATIVAR" : "ATIVAR"
      } modalidade ?`}
      titleSecondary={
        !isActiveModalidade
          ? "Modalidade não será REMOVIDA ! Apenas será desativado para uso do sistema."
          : "Modalidade ficará disponível para uso do sistema."
      }
      yes={`Sim, ${!isActiveModalidade ? "Desativar" : "Ativar"} !`}
      onClickFalse={() => setModalIsActiveModalidade(false)}
      onClickTrue={() => handleIsActiveModalidade()}
    />
  );
};
